import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
export const findSnapOrder= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-advert/v1/order?`+params,
        method: 'GET'
    })
}
export const findSnapOrderDownloadExcel= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-advert/v1/order/downloadExcel?`+params,
        method: 'GET'
    })
}
export const sendSnapOrder = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-advert/v1/order/${temp}`,
        method: 'PUT'
    })
}